function RetryOnError(maxRetries: number = 1) {
    return function (_target: any, _propertyKey: string, descriptor: PropertyDescriptor) {
        const originalMethod = descriptor.value;
        descriptor.value = async function (this: any, ...args: any[]) {
            let retryCount = 0;
            while (retryCount <= maxRetries) {
                try {
                    const result = await originalMethod.call(this, ...args, retryCount);
                    const is406 = result?.meta?.code === 406;
                    if (is406 && retryCount < maxRetries) {
                        retryCount++;
                        continue;
                    }
                    return result;
                } catch (error) {
                    if (retryCount === maxRetries) {
                        throw error;
                    }
                    retryCount++;
                }
            }
        };
        return descriptor;
    };
}

export default RetryOnError;